import { render, staticRenderFns } from "./zhoubao.vue?vue&type=template&id=510130cc&scoped=true&"
import script from "./zhoubao.vue?vue&type=script&lang=js&"
export * from "./zhoubao.vue?vue&type=script&lang=js&"
import style0 from "./zhoubao.vue?vue&type=style&index=0&id=510130cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510130cc",
  null
  
)

export default component.exports